import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FFF7EC] px-6 text-center">
      <Seo title="Page not found" description="The page you're looking for doesn't exist." />
      <p className="font-display text-8xl text-[#F49E1A]">404</p>
      <h1 className="font-display text-4xl text-[#2A1808] mt-4">This path leads nowhere</h1>
      <p className="mt-3 text-[#553204]">Let's get you back to somewhere beautiful.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="rounded-full btn-orange px-7 py-3 text-sm">Home</Link>
        <Link to="/packages" className="rounded-full border border-[#553204]/20 px-7 py-3 text-sm text-[#2A1808] hover:bg-[#553204]/5">Browse journeys</Link>
      </div>
    </div>
  );
}
